import AdminLayout from '../layouts/AdminLayout.jsx';
import Admin from '../pages/admin/Admin.js';
import Inbox from '../pages/admin/inbox/inbox.js';
import Contacts from '../pages/admin/contacts/contacts.js';
import Sent from '../pages/admin/sent/sent';
import Reports from '../pages/admin/report/report';
import History from '../pages/admin/history/history.js';
import Appointments from '../pages/admin/appointments/appointments.js';
import MessageTemplate from '../pages/admin/messagetemplate/messagetemplate.js';
import Groups from '../pages/admin/groups/groupindex.js';
import PatientGroups from '../pages/admin/groups/patientgroup.js';
import Compose from '../pages/admin/compose/compose.js';
import TemplateSetting from '../pages/admin/messagetemplate/setting.js';

export const adminRoutes = [
	// Admin Pages
	{
		path: '/admin',
		element: Admin,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/',
		element: Inbox,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/inbox',
		element: Inbox,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/sent',
		element: Sent,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/contacts',
		element: Contacts,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/report',
		element: Reports,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/report/:activeReportType',
		element: Reports,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/history',
		element: History,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/history/:phoneNumberId',
		element: History,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/appointments',
		element: Appointments,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/groups',
		element: Groups,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/groups/patientgroup',
		element: PatientGroups,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/groups/patientgroup/:groupId',
		element: PatientGroups,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/messagetemplate',
		element: MessageTemplate,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/compose',
		element: Compose,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/setting',
		element: TemplateSetting,
		layout: AdminLayout,
		adminPage: true
	},
	{
		path: '/automatedmessagetemplate',
		element: MessageTemplate,
		layout: AdminLayout,
		adminPage: true
	}
]